import { render, staticRenderFns } from "./ExchangeRecordDialog.vue?vue&type=template&id=501cdbec&scoped=true"
import script from "./ExchangeRecordDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./ExchangeRecordDialog.vue?vue&type=style&index=0&id=501cdbec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501cdbec",
  null
  
)

export default component.exports